import { produtosReducers } from './produtosReducers';
import { combineReducers } from 'redux';

export const Reducers = combineReducers({
    produtosState: produtosReducers
});